/* eslint-disable */
const ROOT = "";
const Proxy = "/api";

const HOMEBEFORE = {
  BANNERLIST: ROOT + Proxy + "/guest/bannerList", // 获取所有banner列表
  FIRSTNAVLIST: ROOT + Proxy + "/guest/firstNavList", // 获取所有一级导航
  GAMELIST: ROOT + Proxy + "/guest/gameList", // 获取最热游戏列表
  GETGAMEPLATFORM: ROOT + Proxy + "/guest/getGamePlatform", // 获取所有的老虎机游戏平台名称列表
  GETSLOTGAMEPLATFORM: ROOT + Proxy + "/guest/getSlotGameByPlatform", //根据游戏平台代码，获取游戏列表
  INDEXFOOT: ROOT + Proxy + "/guest/indexFoot", // PC端获取页脚信息
  INDEXOFFER: ROOT + Proxy + "/guest/indexOffer", // 获取首页优惠列表
  NAVLISTBYPARENTID: ROOT + Proxy + "/guest/navListByParentId", // 获取非一级导航
  PUSHINFOLIST: ROOT + Proxy + "/guest/pushInfoList", // 根据条件获取需要推送的信息
  serverInfo: ROOT + Proxy + "/guest/serverInfo", // 游客获取服务器信息
  allGameInfo: ROOT + Proxy + "/guest/allGameInfo", // 所有游戏平台
  platformPicInfo: ROOT + Proxy + "/guest/platformPicInfo", // 获取所有平台图片
  // service:ROOT +  Proxy + '/guest/init', // 获取客服链接
  download: ROOT + Proxy + "/init", //获取下载链接
  sportinfo: ROOT + "/sport/", //获取比赛信息
  fetchimg: ROOT + Proxy + "/guest/fetchImg", //图片组
  fetchImgs: ROOT + Proxy + "/guest/fetchImgs", // 根据Code获取配置图片
  // 获取365体育信息
  getCustomizeMatch: ROOT + Proxy + "/guest/getCustomizeMatch", // 获取365体育信息
  getMatchByPlatformCode: ROOT + Proxy + "/guest/getMatchByPlatformCode", // 印度获取365体育信息 新接口
  // 获取排行榜数据
  getrankingList: ROOT + Proxy + "/guest/leaderboard/query",
  // 获取公益视频
  getGoodVedio: ROOT + Proxy + "/guest/leaderboard/getGoodVedio",

  getVipInfoLis: ROOT + Proxy + "/guest/vipinfo/showVIpInfo", // 获取VIP数据
  // 获取热门游戏以及平台
  newHeatGamePlatform: ROOT + Proxy + "/game/guest/newHeatGamePlatform",
  getRegisterList: ROOT + Proxy + "/guest/queryRegisterItem", // 自定义注册项
};
const HOMEAFTER = {
  queryAgentBonus: ROOT + Proxy + "/register/queryAgentBonus", //获取注册用户是否为代理注册
  DEVIVEINFO: ROOT + Proxy + "/loged/deviceInfo", // 获取用户设备信息
  logedUserInfo: ROOT + Proxy + "/loged/logedUserInfo", // 返回所有登录后一级页面需要的用户信息
  refreshUserInfo: ROOT + Proxy + "/loged/refreshUserInfo", // PC端首页顶部刷新按钮
  refresh: ROOT + Proxy + "/loged/refresh", // 检测登录状态
  queryUserLockAmount: ROOT + Proxy + "/loged/queryUserLockAmount", // 查询会员账户锁定金额记录
  selfUnlockAmount: ROOT + Proxy + "/loged/selfUnlockAmount", // 会员自助解锁锁定金额
  getminLimit: ROOT + Proxy + "/loged/minLimit", // 最低取款额
  getusdtRate: ROOT + Proxy + "/loged/usdtRate", // USDT汇率
  getfrontconfig: ROOT + Proxy + "/guest/frontConfig/getFrontConfig", // 365代理联系方式
  getFrontConfigList: ROOT + Proxy + "/guest/frontConfig/getFrontConfig/list", // 365所有代理联系方式
  getWithdrawRange: ROOT + Proxy + "/loged/withdrawRange", //取款最大取款额限制
  userCheckInit: ROOT + Proxy + "/loged/userCheckInit", // 每日活动初始化接口
  checkInHistory: ROOT + Proxy + "/loged/checkInHistory", // 每日活动奖金记录接口
  integralExchangeHistory: ROOT + Proxy + "/loged/integralExchangeHistory", // 钻石兑换记录
  openChest: ROOT + Proxy + "/loged/openChest", // 开宝箱
  exchangeDiamond: ROOT + Proxy + "/loged/exchangeDiamond", // 钻石兑换
};
const USER = {
  thirAuthLogin: ROOT + Proxy + "/guest/thirAuthLogin", //第三方登录
  telegramAuthLogin: ROOT + Proxy + "/guest/telegramAuthLogin", //登录telegram
  bindingAccount: ROOT + Proxy + "/guest/bindingAccount", // 绑定账号
  REGISTER: ROOT + Proxy + "/guest/registered", // 注册
  GOAWINREGISTER: ROOT + Proxy + "/guest/registeredGOA", // 新GAWIN注册
  REGISTERSPT: ROOT + Proxy + "/guest/registeredSPT", // 805注册
  searchUserAccount: ROOT + Proxy + "/guest/searchUserAccount", // 注册检测
  registeredNew: ROOT + Proxy + "/guest/registeredNew", // (多彩宝)注册
  REGISTERCODE: ROOT + Proxy + "/guest/defaultKaptcha", // 验证码
  LOGIN: ROOT + Proxy + "/login", // 登录
  FIRSTUSERINFO: ROOT + Proxy + "/loged/firstUserInfo", // 首次登录信息
  LOGINOUT: ROOT + Proxy + "/loged/logout", // 登出
  MYCOLLECTION: ROOT + Proxy + "/loged/myCollection", // 我的收藏
  LASTSCAN: ROOT + Proxy + "/loged/lastScan", // 最近浏览过的游戏
  updateLoginPassword: ROOT + Proxy + "/loged/updateLoginPassword", // 更改登录密码
  confirm: ROOT + Proxy + "/guest/forget/confirm", // 忘记密码功能：第二步，输入账号、手机/邮箱，加类型，验证码，密码，确认密码
  sendCode: ROOT + Proxy + "/guest/forget/sendCode", // 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  sendCodeNew: ROOT + Proxy + "/guest/forget/sendCodeNew", // (多彩宝) 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  sendVerifictionCode:
    ROOT + Proxy + "/guest/lottery/login/sendVerifictionCode", //手机验证码登录
  myOfferEkList: ROOT + Proxy + "/loged/myOfferEkList", //获取我的优惠列表ekbet
  searchAgentAccount: ROOT + Proxy + "/guest/searchAgentAccount", //注册前检查代理账号是否可以使用
  registAgent: ROOT + Proxy + "/guest/registAgent", //代理注册
};

//  queryLotteryResultList  queryLatestOnlineNumber query48HourOnlineNumberList 为火石接口,跑105前在config切换环境
const GAME = {
  gamePlatform: ROOT + Proxy + "/game/guest/gamePlatform", // 获取游戏类型列表
  heatGamePlatform: ROOT + Proxy + "/game/guest/heatGamePlatform", //获取热门
  topFlowData: ROOT + Proxy + "/logged/topFlowData", // 获取今日流水
  searchResult: ROOT + Proxy + "/guest/searchResult", // 搜索
  queryLotteryResultList:
    ROOT + Proxy + "/guest/lottery/queryLotteryResultList", //获取开奖记录
  queryLatestOnlineNumber:
    ROOT + Proxy + "/guest/lottery/queryLatestOnlineNumber", //最新steam在线人数
  query48HourOnlineNumberList:
    ROOT + Proxy + "/guest/lottery/query48HourOnlineNumberList", //48小时在线
  allGame: ROOT + Proxy + "/game/guest/allGame", // 平台全部游戏（棋牌等..）
  newGame: ROOT + Proxy + "/game/guest/newGame", // 平台最新游戏（棋牌等..）
  hotGame: ROOT + Proxy + "/game/guest/hotGame", // 平台热门游戏（棋牌等..）
  //筛选游戏
  queryAllGameList: ROOT + Proxy + "/game/guest/queryAllGameList",
  gameUrl: ROOT + Proxy + "/game/gameUrl",
  guestGameUrl: ROOT + Proxy + "/game/guest/gameUrl",
};

// slot-controller 老虎机的首页接口
const SLOT = {
  slotBanner: ROOT + Proxy + "/guest/slotBanner", // 老虎机banner
  slotOffer: ROOT + Proxy + "/guest/slotOffer", // 老虎机相关优惠
  slotRank: ROOT + Proxy + "/guest/slotRank", // 老虎机压码排行
  totalSlot: ROOT + Proxy + "/guest/totalSlot", // 老虎机全部游戏
  maybeLike: ROOT + Proxy + "/logged/maybeLike", // 可能喜欢
  mySlot: ROOT + Proxy + "/logged/mySlot", // 我的游戏列表
  addCollection: ROOT + Proxy + "/logged/addCollection", // 添加游戏至我的收藏
  cancelCollection: ROOT + Proxy + "/logged/cancelCollection", // 取消收藏
  selectGameSlotType: ROOT + Proxy + "/guest/selectGameSlotType", //筛选游戏
};
const VIP = {
  VIPPRIVILEGE: ROOT + Proxy + "/guest/vipPrivilege", // VIP特权
  CHECKIN: ROOT + Proxy + "/loged/checkin", // 签到
  CHECKININFO: ROOT + Proxy + "/loged/checkinInfo", // 签到的信息
  LOTTERY: ROOT + Proxy + "/loged/lottery", // 签到抽奖
  inviteCode: ROOT + Proxy + "/loged/inviteCode", // 生成邀请码
  inviteList: ROOT + Proxy + "/loged/inviteList", // 生成邀请列表
  getInviteBonus: ROOT + Proxy + "/loged/getInviteBonus", // 点击领取奖金按钮，领取奖金
  myBalanceList: ROOT + Proxy + "/loged/myBalanceList", // 我的账单列表
  balanceDetail: ROOT + Proxy + "/loged/balanceDetail", // 账单详情
  getMsgSiteList: ROOT + Proxy + "/loged/getMsgSiteList", // 站内信
  updateMsgSite: ROOT + Proxy + "/loged/updateMsgSite", // 站内信状态
  deleteMsgSite: ROOT + Proxy + "/loged/deleteMsgSite", //删除站内信
  insertMsgSite: ROOT + Proxy + "/loged/insertMsgSite", //会员发送信息
  myOrderList: ROOT + Proxy + "/loged/selectUserPayOrderList", // 会员存款订单列表查询
};

const DISCOUNTS = {
  OFFERBANNER: ROOT + Proxy + "/guest/offerBanner", // 优惠板块的banner
  OFFERLIST: ROOT + Proxy + "/guest/offerList", // 根据条件筛选
  OFFERTYPELIST: ROOT + Proxy + "/guest/offerTypeList", // 获取优惠类型
  MYOFFER: ROOT + Proxy + "/loged/myOffer", // 获取我的优惠列表
  queryBonusArticleTypeList: ROOT + Proxy + "/guest/queryBonusArticleTypeList", // （新）获取优惠类型
  queryBonusArticleInfoList: ROOT + Proxy + "/guest/queryBonusArticleInfoList", // （新）获取优惠列表
  querySelfApplyBonusList: ROOT + Proxy + "/guest/querySelfApplyBonusList", //活动大厅列表
  queryBonusArticleInfoDetail:
    ROOT + Proxy + "/guest/queryBonusArticleInfoDetail", //活动大厅获取文章
  offerDetail: ROOT + Proxy + "/guest/offerDetail", // 进入优惠详情
  relatedOffer: ROOT + Proxy + "/guest/relatedOffer", // 获取游戏的相关优惠
  // 大转盘
  queryTurntableRaffle: ROOT + Proxy + "/activity/guest/queryRaffle", // 大转盘抽奖 未登录
  raffle: ROOT + Proxy + "/activity/raffle", // 大转盘抽奖 已登录
  queryHistoryWin: ROOT + Proxy + "/activity/queryHistoryWin", // 大转轮历史记录
  realTimeAmountAll: ROOT + Proxy + "/guest/realTimeAmountAll", // 获取所有可领取的时时流水金额
  getRealTimeAmountAll: ROOT + Proxy + "/guest/getRealTimeAmountAll", // 领取所有可领取的时时流水金额
  realTimeRecord: ROOT + Proxy + "/guest/realTimeRecord", // 获取流水优惠记录
};
// money
const WALLET = {
  RECHARGE: ROOT + Proxy + "/indexpay/webpay_gateway",
  withdrawList: ROOT + Proxy + "/logged/withdrawList",
  refreshGameAccount: ROOT + Proxy + "/logged/refreshGameAccount", // 账户刷新
  balance: ROOT + Proxy + "/game/balance", //  获取平台余额
  gameHistory: ROOT + Proxy + "/game/logged/gameHistory", //  获取平台余额
  newgameHistory: ROOT + Proxy + "/game/logged/newGameHistory", //  获取平台余额
  betFlowLockList: ROOT + Proxy + "/logged/betFlowLock/list", //取款稽核  取款首页列表
};

// 支付方式
const PAY = {
  addBankCard: ROOT + Proxy + "/loged/addBankCard", // 添加银行卡
  deleteBank: ROOT + Proxy + "/loged/deleteBank", // 删除银行卡
  bankCardList: ROOT + Proxy + "/loged/bankCardList", // 获取银行卡列表
  newBankCardList: ROOT + Proxy + "/loged/newBankCardList", // 获取银行卡列表（新）
  bankNameList: ROOT + Proxy + "/logged/inBanks/list", // 银行名称列表
  checkBankCard: ROOT + Proxy + "/loged/checkBankCard", // 验证银行卡信息
  payType: ROOT + Proxy + "/loged/payType", // 获取支付类型
  newPayType: ROOT + Proxy + "/loged/payType/v2", // 获取新支付类型
  payConfig: ROOT + Proxy + "/loged/payConfig/v2", // 获取支付的内容
  indiaDeposit: ROOT + Proxy + "/bankpay/inPayOrder", // 印度存款接口
  inPayUSDTOrder: ROOT + Proxy + "/bankpay/inPayUSDTOrder", //印度USDT存款
  sendWithdrawYZM: ROOT + Proxy + "/loged/sendWithdrawYZM", // 发送提款密码验证码 / 修改邮箱验证码
  setWithdrawPW: ROOT + Proxy + "/loged/setWithdrawPW", // 设置提款密码
  updateWithdrawPW: ROOT + Proxy + "/loged/updateWithdrawPW", // 修改提款密码
  updateWithdrawPWGOA: ROOT + Proxy + "/loged/updateWithdrawPWGOA", // goa新版修改提款密码
  applyWithdraw: ROOT + Proxy + "/loged/applyWithdraw", // 申请提现
  deposit: ROOT + Proxy + "/loged/deposit", // 向游戏平台转账
  withdraw: ROOT + Proxy + "/loged/withdraw", // 向中心钱包转账
  getAllPlatform: ROOT + Proxy + "/loged/getAllPlatform", // 获取所有平台
  withdrawGames: ROOT + Proxy + "/loged/withdrawGames", // 取出全部的金额，用于提现等页面
  indepositOrderlist: ROOT + Proxy + "/logged/depositOrder/list", //印度存款订单列表
  incancelOrder: ROOT + Proxy + "/logged/cancelOrder", //印度取消订单
  DJS: ROOT + Proxy + "/logged/deposit/djs", //获取倒计时  payExpirationTimeOnlne.  线上倒计时，如果为空没有 payExpirationTime 公司入款倒计时

  uploadFile: ROOT + Proxy + "/uploadFile", //图片上传
  inPayOrder: ROOT + Proxy + "/bankpay/inPayOrder", //印度存款
  inPayOrderGOA: ROOT + Proxy + "/bankpay/inPayOrderGOA", //新版 goawin 存款
  inBanks: ROOT + Proxy + "/logged/inBanks/list", //获取印度银行卡列表
  myOfferEkCount: ROOT + Proxy + "/loged/myOfferEkCount", //优惠记录统计

  offlineAuto: ROOT + Proxy + "/offlineAuto/payOrder", //自动上分
  autoBanks: ROOT + Proxy + "/logged/autoBanks/list", //自动上分银行卡列表
  semiAutomatic: ROOT + Proxy + "/semiAutomatic/payOrder", // 半自动上分
};
// 帮助/关于我们板块接口
const HELP = {
  articleById: ROOT + Proxy + "/guest/articleById", // 根据文章id获取文章
  articleListByType: ROOT + Proxy + "/guest/articleListByType", // 根据文章类型获取文章列表
  articleType: ROOT + Proxy + "/guest/articleType", // 获取文章类型
  pushInfo: ROOT + Proxy + "/guest/pushInfo", // 获取当前时间的推送通知-未登录状态
  logedPushInfo: ROOT + Proxy + "/loged/pushInfo", // 获取所有推送和通知-已登录状态
};
// 认证
const CONFIRM = {
  confirmEmail: ROOT + Proxy + "/loged/confirmEmail", // 邮箱认证
  confirmPhone: ROOT + Proxy + "/loged/confirmPhone", // 手机验证
  confirmRealName: ROOT + Proxy + "/loged/confirmRealName", // 实名认证接口
  confirmQQ: ROOT + Proxy + "/loged/confirmQQ", //qq认证
  confirmWeChat: ROOT + Proxy + "/loged/confirmWeChat", //微信认证
  email: ROOT + Proxy + "/loged/email", // 发送邮箱验证
  sendPhone: ROOT + Proxy + "/loged/sendPhone", // 发送手机验证码
  updateEmail: ROOT + Proxy + "/loged/updateEmail", // 修改邮箱

  queryCountryList: ROOT + Proxy + "/guest/search/queryCountryList", // (多彩宝)获取电话国家列表
  sendPhoneSMS: ROOT + Proxy + "/loged/sendPhoneSMS", // （多彩宝）发送验证码

  sendVerify: ROOT + Proxy + "/guest/phone/sendVerify", // 注册页面发送验证码

  //build09邮箱验证
  submitEmail: ROOT + Proxy + "/loged/submitEmail", //build09新邮箱验证

  submitBirthDay: ROOT + Proxy + "/vipDeposit/submitBirthDay", // 绑定生日
};
// 存款红利
const DEPOSIT = {
  showIndexInfo: ROOT + Proxy + "/deposit/showIndexInfo", // 首页展示信息 - 存款红利
  showPrizeInfo: ROOT + Proxy + "/deposit/showPrizeInfo", // 进入抽奖页面，获取奖品展示的接口，如果没有那么展示静态奖品
  clickButton: ROOT + Proxy + "/deposit/clickButton", // 点击抽奖按钮
  applyBonus: ROOT + Proxy + "/deposit/applyBonus", // 申请存款红利
  vipapplyBonus: ROOT + Proxy + "/vipDeposit/getVipReward", // 申请VIP红利
  otherApplyBonus: ROOT + Proxy + "/other/applyBonus", // 申请存款红利
  getRealTimeAmount: ROOT + Proxy + "/guest/getRealTimeAmount", //时时返水红利
  getUserAgentBonus: ROOT + Proxy + "/loged/userAgentBonus",
  applyPrivateBonus: ROOT + Proxy + "/applyBonus/applyPrivateCustomBonus", // 领取私人定制福利
  queryBonusBindUserInfoList:
    ROOT + Proxy + "/guest/queryBonusBindUserInfoList", //查询会员绑定优惠
  selectUserUpgradeInfo: ROOT + Proxy + "/deposit/selectUserUpgradeInfo", //升级优惠

  // 领取福利
  receiveMyBonus: ROOT + Proxy + "/loged/receiveMyBonus",

  // 余额宝
  availableYEBList: ROOT + Proxy + "/applyBonus/selectBonusBalanceProfitList", // 查询可购买的余额宝列表
  purchasedYEBList: ROOT + Proxy + "/applyBonus/queryUserBuyBalanceProfitList", // 查询已购买的余额宝列表
  buyYEBProgram: ROOT + Proxy + "/applyBonus/buyBalanceProfit", // 购买余额宝
  ransomYEBProgram: ROOT + Proxy + "/applyBonus/ransomBalanceProfit", // 赎回余额宝
  receiveMyBonus: ROOT + Proxy + "/loged/receiveMyBonus",
  getVipRewardGift: ROOT + Proxy + "/vipDeposit/getVipRewardGift", // VIP页面领取接口  1晋升礼金2生日礼金3节日礼金
  fastApplyPromotion: ROOT + Proxy + "/vipDeposit/fastApplyPromotion", // VIP快速晋级申请
};

//签到
const SIGN = {
  checkIntegralConfigList: ROOT + Proxy + "/loged/checkIntegralConfigList", //签到可以获得奖励列表
  getUserIntegral: ROOT + Proxy + "/loged/getUserIntegral", //获取用户当前积分信息
  getUserCheckInfo: ROOT + Proxy + "/loged/getUserCheckInfo", //获取用户当前签到信息
  userCkeckIn: ROOT + Proxy + "/loged/userCheckIn", //用户点击签到
  checkInHistory: ROOT + Proxy + "/loged/checkInHistory", //会员签到积分领取记录
  //积分
  bonusExchangeConfigList: ROOT + Proxy + "/loged/bonusExchangeConfigList", //兑换可以获得奖励列表
  bonusIntegralExchange: ROOT + Proxy + "/loged/bonusIntegralExchange", //兑换积分
  bonusExchangeHistory: ROOT + Proxy + "/loged/bonusExchangeHistory", //兑换积分记录
};

// 快速存取款
const FastPay = {
  amountList: ROOT + Proxy + "/reserve/amountList", //获取可用金额组
  reserveWithdrawConfig: ROOT + Proxy + "/loged/reserveWithdrawConfig", // 获取会员是否可见预约取款通道
  confirmReserveWithdrawOrder:
    ROOT + Proxy + "/reserve/confirmReserveWithdrawOrder", // 预约存取款：确认提现订单
  amountGroup: ROOT + Proxy + "/reserve/amountGroup", // 预约存取款：存款区间列表
  myPayOrder: ROOT + Proxy + "/reserve/myPayOrder", // 预约存取款：查询我的极速存款订单
  createOrder: ROOT + Proxy + "/reserve/createOrder", // 预约存取款：选择金额下单
  uploadPayPhoto: ROOT + Proxy + "/reserve/uploadPayPhoto", // 上传凭证
  reminders: ROOT + Proxy + "/reserve/reminders", // 催单接口
  payConfirm: ROOT + Proxy + "/reserve/payConfirm", // 会员确认订单已付款
  cancelOrder: ROOT + Proxy + "/reserve/cancelOrder", // 预约存取款：取消支付
};

// 上传文件
const uploadFile = ROOT + Proxy + "/uploadFile";

//时时乐
// const TIMELE = {
//   allGame:ROOT +  Proxy + '/guest/realTimeLe/allGame', //获取所有游戏
//   allInfo:ROOT +  Proxy + '/guest/realTimeLe/allInfo', //获取时时乐所有信息
//   bettingList:ROOT +  Proxy + '/guest/realTimeLe/bettingList', //时时乐多条记录下注
//   bettingVo:ROOT +  Proxy + '/guest/realTimeLe/bettingVo', //时时乐单条记录下注
//   getHero:ROOT +  Proxy + '/guest/realTimeLe/getHero', //根据portId获取该游戏的英雄和属性
//   getList:ROOT +  Proxy + '/guest/realTimeLe/getList', //获取时时乐注单记录
//   getRealTimeLe:ROOT +  Proxy + '/guest/realTimeLe/getRealTimeLe', //根据portId获取时时乐实时信息
//   getRealTimeLe:ROOT +  Proxy + '/guest/realTimeLe/getResult', //获取开奖记录,只能获取1天以内的
//   getSportPlay:ROOT +  Proxy + '/guest/realTimeLe/getSportPlay', //根据portId获取该游戏的投注玩法
// }

// build02-多彩宝
const color_download = "https://www.baidu.com";

// goldThemes - 金色
const goldThemes_download = "https://www.baidu.com";
const goldThemes_service = "https://www.baidu.com";

// lyh5 -红色
const lyh5_download = "https://www.baidu.com";
const lyh5_service = "https://www.baidu.com";

// build01 威尼斯黑金版
const venice_gold_download = "";
const venice_gold_service = "";

// 金沙
const jin_download = "";

//Build04下载
const four_download = "https://www.baidu.com";

// build06 太阳城
const sun_gold_download = "#";
const sun_gold_service = "";

// 2668.com-威尼斯版本
const service_2668 = "https://chat.livechatvalue.com/";

export default {
  HOMEBEFORE: HOMEBEFORE,
  HOMEAFTER: HOMEAFTER,
  DISCOUNTS: DISCOUNTS,
  USER: USER,
  SLOT: SLOT,
  WALLET: WALLET,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  SIGN,
  uploadFile,
  // TIMELE,

  color_download,
  goldThemes_download,
  lyh5_download,
  venice_gold_download,
  jin_download,
  four_download,
  sun_gold_download,

  goldThemes_service,
  lyh5_service,
  venice_gold_service,
  sun_gold_service,
  FastPay,
  service_2668,
};



// WEBPACK FOOTER //
// ./src/common/urls/url.js